import dayjs from 'dayjs'
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react'
import React, { useEffect, useRef, useState } from 'react'
import { Getdata } from '../helpers/api.service'

const Calendar = () => {
    const container = useRef(null)

    const [currentWeekStart, setCurrentWeekStart] = useState(dayjs().startOf('week').add(1, 'day'))
    const [currentTime, setCurrentTime] = useState(dayjs())

    const [modalOpen, setModalOpen] = useState(false)
    const [showColorPicker, setShowColorPicker] = useState(false)
    const [editingIndex, setEditingIndex] = useState(null)
    const [editingDate, setEditingDate] = useState(null)

    const [formData, setFormData] = useState({
        id: null,
        title: '',
        date: '',
        start_time: '',
        end_time: '',
        place: '',
        members: [],
        notes: '',
        color: '#facc15',
        board_members: [],
    })
    const [events, setEvents] = useState({})
    const [member, setMember] = useState([])
    const [boardMember, setBoardMember] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const [hoveredEvent, setHoveredEvent] = useState(null)
    const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 })
    const hideTimer = useRef(null)
    const [refresh, setRefresh] = useState(false)
    const [currentDate, setCurrentDate] = useState(dayjs());

    const goToToday = () => setCurrentDate(dayjs());
    const goToPrevious = () => {
        setCurrentDate(currentDate.subtract(1, 'week'));


    };
    const goToNext = () => {
        setCurrentDate(currentDate.add(1, 'week'));


    };

    const renderDateRange = () => {

        const startOfWeek = currentDate.startOf('week').add(1, 'day');
        const endOfWeek = currentDate.endOf('week').add(1, 'day');
        return `${startOfWeek.format('MMM D')} – ${endOfWeek.format('D, YYYY')}`;


    };

    const showTooltip = (event, target) => {
        clearTimeout(hideTimer.current)
        const rect = target.getBoundingClientRect()
        const tooltipWidth = 260 // or whatever your tooltip width is
        const alignLeft = rect.left + tooltipWidth > window.innerWidth

        setTooltipPosition({
            x: rect.left,
            y: rect.top + window.scrollY,
            alignLeft
        })
        console.log("event>>>>>>>", event)
        setHoveredEvent(event)
    }

    const delayedHideTooltip = () => {
        hideTimer.current = setTimeout(() => setHoveredEvent(null), 2000)
    }
    useEffect(() => {
        setCurrentWeekStart(currentDate.startOf('week').add(1, 'day'));
    }, [currentDate]);

    const fetchBoardMember = () => {
        Getdata(
            process.env.REACT_APP_URL +
            `/front/board-management/fetch/${process.env.REACT_APP_SUBDOMAIN}`)
            .then((res) => {
                setBoardMember(res.data.boards);
            })
            .catch((err) => {
                console.error("Error fetching FAQ:", err);
            });
    }

     const fetchMember = () => {
        Getdata(
            process.env.REACT_APP_URL +
            `/front/management/fetch/${process.env.REACT_APP_SUBDOMAIN}`)
            .then((res) => {
                setMember(res.data.managers);
            })
            .catch((err) => {
                console.error("Error fetching FAQ:", err);
            });
    }

    const fetchData = () => {
        // setLoading(true);
        Getdata(
            process.env.REACT_APP_URL +
            `/front/education/calendar/event/fetch/${process.env.REACT_APP_SUBDOMAIN}`)
            .then((res) => {
                const grouped = {};
                res.data.forEach(event => {
                    const dateKey = dayjs(event.date).format("YYYY-MM-DD");
                    if (!grouped[dateKey]) grouped[dateKey] = [];
                    grouped[dateKey].push({
                        ...event,
                        _start: dayjs(`${dateKey}T${event.start_time}`),
                        _end: dayjs(`${dateKey}T${event.end_time}`),
                    });
                });
                console.log("grouped>>>>>>>>>>", grouped)
                setEvents(grouped);
            })
            .catch((err) => {
                console.error("Error fetching FAQ:", err);
                // setLoading(false);
            });
    };


    useEffect(() => {
        fetchMember()
        fetchBoardMember()
        fetchData()
        const interval = setInterval(() => setCurrentTime(dayjs()), 60000)
        return () => clearInterval(interval)
    }, [])



    const openEditModal = (event, date, index) => {
        setFormData({ ...event, id: event._id })
        setEditingIndex(index)
        setEditingDate(date)
        setModalOpen(true)
        setShowColorPicker(false)
    }

    //   const fetchBoardMember = () => {
    //     setIsLoading(true)
    //     Postdata(HttpService.board_management_list).then((response) => {
    //       if (response.status === 200) {
    //         setBoardMember(response.data.boards)
    //         setIsLoading(false)
    //       } else {
    //         setIsLoading(false)
    //         dispatch(message(response.message))
    //       }
    //     })
    //   }
    //   const fetchMembers = () => {
    //     setIsLoading(true)
    //     Postdata(HttpService.school_management_list).then((response) => {
    //       if (response.status === 200) {
    //         setMember(response.data.managers)
    //         setIsLoading(false)
    //       } else {
    //         setIsLoading(false)
    //         dispatch(message(response.message))
    //       }
    //     })
    //   }

    //   const fetchEvents = () => {
    //     setIsLoading(true)
    //     Postdata(HttpService.calendar_event_list).then((response) => {
    //       if (response.status === 200) {
    //         const grouped = {};
    //         response.data.forEach(event => {
    //           const dateKey = dayjs(event.date).format("YYYY-MM-DD");
    //           if (!grouped[dateKey]) grouped[dateKey] = [];
    //           grouped[dateKey].push({
    //             ...event,
    //             _start: dayjs(`${dateKey}T${event.start_time}`),
    //             _end: dayjs(`${dateKey}T${event.end_time}`),
    //           });
    //         });
    //         console.log("grouped>>>>>>>>>>", grouped)
    //         setEvents(grouped);
    //         setIsLoading(false)
    //       } else {
    //         setIsLoading(false)
    //         dispatch(message(response.message))
    //       }
    //     })
    //   }

    const handleBoardMemberChange = (selected) => {
        const selectedNames = selected ? selected.map((item) => item.value) : [];
        setFormData({ ...formData, board_members: selectedNames });
    }

    const handleMemberChange = (selected) => {
        const selectedNames = selected ? selected.map((item) => item.value) : [];
        setFormData({ ...formData, members: selectedNames });
    }

    //   useEffect(() => {
    //     fetchEvents()
    //   }, [refresh]);

    //   useEffect(() => {
    //     fetchMembers()
    //     fetchBoardMember()
    //     fetchEvents()
    //   }, [])


    const weekDays = Array.from({ length: 7 }).map((_, i) => currentWeekStart.add(i, 'day'))
    const hours = Array.from({ length: 24 }).map((_, i) => i + 7).slice(0, 24);

    // Handle Event Clustering and Prevent Overflow
    const handleEventClustering = (dayEvents) => {
        const clusters = []
        const parsedEvents = dayEvents
            .map((e, i) => ({
                ...e,
                _index: i,
                _start: dayjs(`${e.date}T${e.start_time}`),
                _end: dayjs(`${e.date}T${e.end_time}`),
            }))
            .sort((a, b) => a._start.diff(b._start))

        parsedEvents.forEach((event) => {
            let placed = false
            for (const cluster of clusters) {
                if (
                    cluster.some((e) => e._start.isBefore(event._end) && e._end.isAfter(event._start))
                ) {
                    cluster.push(event)
                    placed = true
                    break
                }
            }
            if (!placed) clusters.push([event])
        })

        return clusters
    }
    return (
        <div className='bg-white container mx-auto rounded p-4 shadow'>
            {/* Top Navigation Bar */}
            <div className="flex justify-between items-center border-b pb-4">
                {/* Today button */}
                <button
                    onClick={goToToday}
                    className="px-[20px] py-[10px] rounded border text-black font-semibold text-sm"
                >
                    Today
                </button>

                {/* Center controls */}
                <div className="flex items-center space-x-2">
                    <button
                        onClick={goToPrevious}
                        className="p-1 rounded-full border hover:bg-gray-100"
                    >
                        <ChevronLeftIcon className="h-5 w-5" />
                    </button>
                    <span className="text-sm font-medium">
                        {renderDateRange()}
                    </span>
                    <button
                        onClick={goToNext}
                        className="p-1 rounded-full border hover:bg-gray-100"
                    >
                        <ChevronRightIcon className="h-5 w-5" />
                    </button>
                </div>

                {/* View Switcher */}
                <div className="flex items-center space-x-1 border rounded-[50px] overflow-hidden text-sm">
                    {['week'].map((v, idx) => (
                        <button
                            key={v}
                            // onClick={() => setView(v)}
                            className={`px-[15px] py-[10px] 
                                 hover:text-black transition ${"Week" === v ? 'text-black font-semibold' : ''}
                                 ${idx !== 3 ? 'border-r border-gray-300' : ''}
                                 `}
                        >
                            {v.charAt(0).toUpperCase() + v.slice(1)}
                        </button>
                    ))}
                </div>
            </div>

            {/* Calendar Views */}
            <div className="mt-4">


                <div className="flex h-screen flex-col">
                    {/* Header */}
                    {/* <header className="flex items-center justify-between border-b border-gray-200 px-6 py-4">
        <h1 className="text-base font-semibold leading-6 text-gray-900">
          Week of {currentWeekStart.format('MMMM D, YYYY')}
        </h1>
        <div className="flex gap-2">
          <button onClick={() => setCurrentWeekStart(currentWeekStart.subtract(7, 'day'))}>
            <ChevronLeftIcon className="h-5 w-5 text-gray-600" />
          </button>
          <button onClick={() => setCurrentWeekStart(dayjs().startOf('week').add(1, 'day'))} className="text-sm">
            Today
          </button>
          <button onClick={() => setCurrentWeekStart(currentWeekStart.add(7, 'day'))}>
            <ChevronRightIcon className="h-5 w-5 text-gray-600" />
          </button>
        </div>
      </header> */}

                    {/* Day Labels */}
                    <div className="grid grid-cols-8 border-b border-gray-200 bg-gray-50 text-sm font-medium text-gray-700">
                        <div className="border-r border-gray-200 p-2 text-right text-xs text-gray-500">Time</div>
                        {weekDays.map((day, i) => (
                        <div key={i} className="border-r border-gray-200 p-2 text-center">
                            <div className="hidden lg:block">{day.format('dddd')}</div> 
                            <div className="lg:hidden">{day.format('ddd')}</div>
                            <div className="text-xs text-gray-500">{day.format('MMM D')}</div>
                        </div>
                        ))}
                    </div>

                    {/* Grid View */}
                    <div ref={container} className="flex-auto overflow-auto">
                        <div className="grid grid-cols-8 min-w-full">
                            {/* Time Column */}
                            <div className="bg-white border-r border-gray-200">
                                {hours.map((hour) => (
                                    <div key={hour} className="h-20 border-b border-gray-100 text-xs text-right pr-2 pt-1 text-gray-500">
                                        {dayjs().hour(hour).format('h A')}
                                    </div>
                                ))}
                            </div>

                            {/* Day Columns */}
                            {weekDays.map((day, dayIdx) => {
                                const dayKey = day.format('YYYY-MM-DD')
                                const dayEvents = events[dayKey] || []
                                const clusters = handleEventClustering(dayEvents)

                                return (
                                    <div key={dayIdx} className="relative border-r border-gray-200 overflow-y-auto max-h-full">
                                    {hours.map((_, i) => (
                                        <div
                                            key={i}
                                            className="h-20 border-b border-gray-100"
                                            onClick={() => {
                                                const clickedTime = day.hour(i + 7).format('HH:mm') // Adjusted time click to start at 7 AM
                                                setFormData({
                                                    title: '',
                                                    date: dayKey,
                                                    start_time: clickedTime,
                                                    end_time: clickedTime,
                                                    place: '',
                                                    members: [],
                                                    board_members: [],
                                                    notes: '',
                                                    color: '#facc15',
                                                })
                                                setModalOpen(true)
                                                setEditingIndex(null)
                                                setEditingDate(null)
                                                setShowColorPicker(false)
                                            }}
                                        />
                                    ))}

                                    {/* Current Time Line */}
                                    {currentTime.isSame(day, 'day') && (
                                        <div
                                            className="absolute left-0 right-0 h-0.5 bg-red-500 z-10"
                                            style={{ top: `${(currentTime.hour() - 7 + currentTime.minute() / 60) * 80}px` }} // Adjust for 7 AM start
                                        />
                                    )}

                                    {/* Events with overlapping support */}
                                    {clusters.flatMap((cluster) => {
                                        const total = cluster.length
                                        return cluster.map((event, i) => {
                                            const eventStartHour = event._start.hour() - 7 + (event._start.minute() / 60) // Adjust event start time for 7 AM
                                            const top = eventStartHour * 80 // Calculate top based on adjusted time
                                            const height = (event._end.diff(event._start, 'minute') / 60) * 80 // Event height based on duration
                                            const widthPercent = 100 / total
                                            const leftPercent = i * widthPercent

                                            return (
                                               <div
                                                    key={event.title + event.start_time + i}
                                                    className="absolute z-20 text-xs leading-5 text-white shadow cursor-pointer overflow-hidden rounded"
                                                    style={{
                                                        top: `${top}px`,
                                                        height: `${height}px`,
                                                        width: `calc(${widthPercent}% - 6px)`,
                                                        left: `calc(${leftPercent}% + 2px)`,
                                                        backgroundColor: event.color,
                                                        minWidth: '60px',
                                                        padding: '6px',
                                                        whiteSpace: 'normal',
                                                        // wordBreak: 'break-word',
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        justifyContent: 'start',
                                                        alignItems: 'start',
                                                    }}
                                                    onPointerEnter={(e) => showTooltip(event, e.currentTarget)}
                                                    onPointerLeave={delayedHideTooltip}
                                                    onClick={() => openEditModal(event, event.date, event._index)}
                                                    >
                                                    <strong className="text-[11px] font-semibold w-full sm:text-[12px] md:text-[14px]">
                                                        {event.title}
                                                    </strong>
                                                    <div className="text-[10px] sm:text-[11px] md:text-[12px] w-full">
                                                        {event._start.format('h:mm A')}
                                                        <span className="hidden lg:inline"> – </span>
                                                        <p className="lg:hidden  -m-1.5  ">  to </p>
                                                        {event._end.format('h:mm A')}
                                                    </div>
                                                </div>
                                            )
                                        })
                                    })}
                                </div>

                                )
                            })}
                        </div>
                    </div>

                    {hoveredEvent && (
                        <div
                            className="absolute z-50 bg-white rounded-md shadow-lg p-3 text-sm border w-64"
                            style={{
                                top: tooltipPosition.y + 10,
                                left: tooltipPosition.alignLeft
                                    ? tooltipPosition.x - 270 // move left
                                    : tooltipPosition.x + 10 // move right
                            }}
                            onPointerEnter={() => clearTimeout(hideTimer.current)}
                            onPointerLeave={delayedHideTooltip}
                        >
                            <h4 className="font-semibold text-gray-800 mb-1">{hoveredEvent.title}</h4>
                            <p className="text-xs text-gray-600 mb-1">
                                {hoveredEvent._start.format('dddd, MMM D')}<br />
                                {hoveredEvent._start.format('h:mm A')} – {hoveredEvent._end.format('h:mm A')}
                            </p>
                            {hoveredEvent.place && <p><strong>Place:</strong> {hoveredEvent.place}</p>}
                            {hoveredEvent.members && hoveredEvent.members.length > 0 && (
                                <p>
                                    <strong>Members:</strong>{" "}
                                    {member
                                        .filter(m => hoveredEvent.members.includes(m._id))
                                        .map(m => m.name)
                                        .join(", ")}
                                </p>
                            )}
                            {hoveredEvent.board_members && hoveredEvent.board_members.length > 0 && (
                                <p>
                                    <strong>Board Members:</strong>{" "}
                                    {boardMember
                                        .filter(m => hoveredEvent.board_members.includes(m._id))
                                        .map(m => m.name)
                                        .join(", ")}
                                </p>
                            )}
                            {hoveredEvent.notes && <p><strong>Notes:</strong> {hoveredEvent.notes}</p>}
                            {/* <div className="mt-3 flex gap-2 justify-end">
             <button
              className="text-xs text-indigo-600 hover:underline"
              onClick={() => {
                openEditModal(hoveredEvent, hoveredEvent.date, hoveredEvent._index)
                setHoveredEvent(null)
              }}
            >
              Edit
            </button>
             <button
            onClick={()=>handleDeleteEvent(hoveredEvent)}
              className="text-xs text-red-600 hover:underline"
            >
              Delete
            </button>
          </div> */}
                        </div>
                    )}


                </div>
            </div>
        </div>
    )
}

export default Calendar